import React from 'react'
import { IconSeeker, PopoverSeeker } from '@ui-seeker/core'
import { Box, Divider, Typography } from '@mui/material'
import { popoverData } from 'Pages/RealTimeHistory/RealTime/@signals'


export default function ErrorDataPopover({ isOpen, onClose }) {


	if (!isOpen) return null

	return <PopoverSeeker
		anchorEl={isOpen}
		onClose={onClose}
		anchorOrigin={{ vertical: 'top' }}
		transformOrigin={{ vertical: 'bottom' }}
		arrowProps={{
			sx: {
				top: "96.5%"
			}
		}}
		slotProps={{ paper: { sx: { p: 2, backgroundColor: 'white' } } }}
	>
		<PopoverContent/>
	</PopoverSeeker>
}

function PopoverContent() {

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "start", gap: .5, maxWidth: "150px", flexWrap: "wrap" }}>
		<Typography sx={{ color: "secondary.main", fontWeight: "bold" }}>Site error statistics</Typography>
		<Divider sx={{ my: .5, width: "100%" }}/>
		{popoverData.value?.map(({ lor, screenshot }) => {
			return <Box
				key={`${lor}-${screenshot}`}
				onClick={e => {
					if(!!screenshot) {
						window.open(screenshot)
						if (e.ctrlKey) {
							e.preventDefault()
						}
					}
				}}
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					borderBottom: "2px solid",
					borderColor: "primary.main",
					cursor: !!screenshot ? "pointer" : "default",
					p: .5,
					gap: .5,
					"&:hover": {
						backgroundColor: !!screenshot && "secondary.lighter",
						borderColor: !!screenshot && "error.main"
					}
				}}
			>
				{!screenshot && <Typography variant="caption" sx={{ color: "secondary.light" }} >LOR:</Typography>}
				<Typography variant="body4">{lor}</Typography>
				 <IconSeeker icon={!!screenshot && "image"} sx={{ color: "secondary.main" }}/>
			</Box>
		})}
	</Box>
}